import { useRiftArtworkPath } from '../utils/riftArtwork';
import React from 'react';
import { riftIdentityStyle } from './riftPresentation';
import { Rift } from '../api';

type RiftMarkerProps = {
  rift: Rift;
  className?: string;
  size?: number;
  identityColor?: boolean;
};

const normalizeRiftColor = (color?: string) =>
  color?.toLowerCase() === 'white' ? 'White' : 'Black';

export const RiftMarker: React.FC<RiftMarkerProps> = ({ rift, className = '', size, identityColor = false }) => {
  const artwork = useRiftArtworkPath();
  const color = normalizeRiftColor(rift.color);
  const dimensionSign = rift.dimensionalSign;
  const label = `${color} ${dimensionSign} rift`;

  return (
    <div
      className={`rift-marker-token rift-marker-${color.toLowerCase()} ${identityColor ? 'rift-identity-artwork' : ''} ${className}`.trim()}
      style={{ ...(identityColor ? riftIdentityStyle(rift.id) : {}), ...(size ? { width: `${size}px`, height: `${size}px` } : {}) }}
      title={label}
    >
      <img
        loading="lazy"
        src={artwork}
        alt={label}
        className="rift-marker-image"
      />
      <img
        loading="lazy"
        src={`/signs/${encodeURIComponent(dimensionSign)}.svg`}
        alt={`${dimensionSign} dimension sign`}
        className="rift-marker-sign"
      />
    </div>
  );
};
